import { CmsApiFourArticlesHighlightBlockData } from 'modules/cms/api/types/blocks/CmsApiFourArticlesHighlightBlock';
import { CmsAmpCardsBlock } from 'modules/cms/blocks/Amp/Cards';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpFourArticlesHighlightBlock({
  content,
  blockId,
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiFourArticlesHighlightBlockData>) {
  return (
    <CmsAmpCardsBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        headline: data.headline,
        cards: ['One', 'Two', 'Three', 'Four']
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          .filter((page) => data[`page${page}`])
          .map((page) => ({
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            image: data[`page${page}`].image,
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            headline: data[`page${page}`].title,
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            url: data[`page${page}`].url,
          })),
        maxLength: 4,
      }}
    />
  );
}
